var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"markdown-content",domProps:{"innerHTML":_vm._s(_vm.compiledMarkdown)}})
}
var staticRenderFns = []

export { render, staticRenderFns }